import { toast } from 'react-toastify';
import { useMutation } from 'react-query';
import Api, { HttpError } from '../../../Lib/api';

export const useSimulateNsRequestToPoService = () =>
  useMutation<void, Error, { method: string; url: string; body: any }>(
    ({ method, url, body }) =>
      Api.post('/dev-tools/ns-call-to-po-service', {
        data: { method, url, body },
      }),
    {
      onError: (error: HttpError) => {
        const errorMessage = error.message;
        const errorStatus = error.status ? `Error ${error.status}` : '';

        toast(`${errorStatus}${errorMessage ? ':' : ''}${errorMessage}`, {
          type: 'error',
          autoClose: 5000,
        });
      },
      onSuccess: () => {
        toast('Request sent successfully', {
          type: 'success',
          autoClose: 5000,
        });
      },
    },
  );
